// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatBot_wrapper__lgoDY","innerWrapper":"ChatBot_innerWrapper__EA-ls"};